import styled from 'styled-components';

export const PageContent = styled.div`
  display: flex;
  gap: 40px;
`;

export const RightContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  max-width: 550px;
  min-width: 432px;
`;
